import { useState, useEffect } from 'react';
import useApi, {
  GET_AVAILABLE_PORTFOLIOS,
  GET_AVAILABLE_HOLDINGS,
  GET_AVAILABLE_PEER_GROUPS
} from 'hooks/useApi';

export default ({ masterObjectTypeId }) => {
  const [masterObjects, setMasterObjects] = useState();
  const [masterObjectTypeIdState, setMasterObjectTypeIdState] = useState(masterObjectTypeId);
  const [isResetReady, setIsResetReady] = useState(false);

  const [state, makeRequest] = useApi();
  const { data, isLoading, isError, error } = state;

  const fetchMasterObjects = id => {
    const getParams = () => {
      switch (`${id}`) {
        case '1':
          return GET_AVAILABLE_PORTFOLIOS();
        case '2':
          return GET_AVAILABLE_PEER_GROUPS();
        case '3':
          return GET_AVAILABLE_HOLDINGS();
        default:
          return null;
      }
    };
    const params = getParams();
    makeRequest(params);
  };

  useEffect(() => {
    setMasterObjects();
    setIsResetReady(true);
  }, [masterObjectTypeIdState]);

  useEffect(() => {
    if (!isResetReady) return;

    fetchMasterObjects(masterObjectTypeIdState);
    setIsResetReady(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isResetReady]);

  useEffect(() => {
    if (isLoading) return;
    if (isError && error) return;

    if (data) {
      const formattedMasterObjects = [...data].map(item => ({
        label: item.name,
        value: item.id || item.timeSeriesId
      }));
      setMasterObjects(formattedMasterObjects);
    }
  }, [isLoading, isError, error, data]);

  return [masterObjects, masterObjectTypeIdState, setMasterObjectTypeIdState];
};
